import { Injectable } from '@angular/core';
import { AppTranslationGateway } from './app-translation.gateway';
import { forkJoin, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppTranslationService {
  /**
   * Constructor
   * @param gateway translation gateway
   */
  constructor(private readonly gateway: AppTranslationGateway) {}

  /**
   * Method to get an async translation
   * @param key translation key
   * @param params extra translation parameters
   * @returns translation
   * */
  getAsync(key: string, params?: Record<string, string>): Observable<string> {
    return this.gateway.getAsync(key, params);
  }

  /**
   * Method to get a sync translation
   * @param key translation key
   * @param params extra translation parameters
   * @returns translation
   */
  get(key: string, params?: Record<string, string>): string {
    return this.gateway.get(key, params);
  }

  /**
   * Method to get multiple translations
   * @param dataToTranslate data to translate
   * @returns translations
   */
  getMany(
    dataToTranslate: { key: string; params?: Record<string, string> }[]
  ): Observable<{ key: string; value: string }[]> {
    const translations$ = dataToTranslate.map((data) =>
      this.getAsync(data.key, data.params)
    );

    return new Observable<{ key: string; value: string }[]>((observer) => {
      forkJoin(translations$).subscribe((translations) => {
        observer.next(
          translations.map((translation, index) => ({
            key: dataToTranslate[index].key,
            value: translation
          }))
        );
        observer.complete();
      });
    });
  }
}
